import type { ZoneType } from '../Zones/types';

export function sortZonesByNewOrder(zones: ZoneType[], order: number[]): ZoneType[] {
    if (order.length === 0) {
        return zones;
    }
    let newZones: ZoneType[] = [];
    for (let i = 0, ii = order.length; i < ii; i++) {
        let index = zones.findIndex(z => z.id == order[i]);
        if (index >= 0) {
            newZones.push({ ...zones[index], order_by: i });
        }
    }
    if (newZones.length < zones.length) {
        throw new Error('sortZonesByNewOrder: some zones are missing');
    }
    return newZones;
}
